/**
 * The catalog area's route table.
 *
 * Exported as a plain map rather than self-registering on import, so the app
 * entry decides when the screens are wired up and nobody has to edit
 * `main.tsx` to add a screen area. `import type { Screen }` keeps this file out
 * of the runtime import graph of `main.tsx`, which boots the app at module
 * scope.
 */

import type { Screen } from "../../main.tsx";

import { Catalog } from "./Catalog.tsx";
import { GameDetail } from "./GameDetail.tsx";
import { Home } from "./Home.tsx";

export const catalogRoutes: Record<string, Screen> = {
  "/": Home,
  "/catalog": Catalog,
  "/game/:id": GameDetail,
};
